import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {PopupHelperService} from "@cybfed/core/services/popup-helper.service";
import { appConstants } from '@cybfed/constants';
import { PublisherService } from '@cybfed/core/services/publisher-service';
import {SkeletonUniversalComponent} from "../skeleton-cards/skeleton-universal/skeleton-universal.component";
import {CustomCheckboxComponent} from "../custom-checkbox/custom-checkbox.component";
import {ImageWrapperComponent} from "../image-wrapper/image-wrapper.component";
import {TranslateModule} from "@ngx-translate/core";
import { NgForOf, NgIf} from "@angular/common";
import {HttpService} from "@cybfed/core/services/http.service";
import {WhiteLabelService} from "@cybfed/core/services/web-site/white-label-service";

@Component({
  selector: 'app-navigate-white-label',
  templateUrl: './navigate-white-label.component.html',
  standalone: true,
  imports: [
    SkeletonUniversalComponent,
    CustomCheckboxComponent,
    ImageWrapperComponent,
    TranslateModule,
    NgIf,
    NgForOf
  ],
  providers: [PublisherService, HttpService, PopupHelperService],
  styleUrls: ['./navigate-white-label.component.scss']
})
export class NavigateWhiteLabelComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter();
  @Output() prev = new EventEmitter();
  @Output() navigateTo = new EventEmitter();
  @Input() whitLabelId:any

  public pubBool: boolean = false;
  public whiteLabels: any;
  errorMessage: any;
  loading: boolean = true;

  constructor(
              private whiteLabelService: WhiteLabelService,
              private popupHelperService: PopupHelperService,
              ) {
  }

  ngOnInit(): void {
    this.getClans()

  }


  getClans() {
    this.loading = true;
    this.whiteLabelService.myList({status: appConstants.PublisherStatus.ACTIVE}).subscribe((data: any) => {
      this.loading = false
      if (!data.hasError) {
        this.whiteLabels = data.data.user.whiteLabels;
        this.pubBool = true
        // this.next = data.data.next
      } else {
        this.errorMessage = data.errorMessages[0].msg;
        this.popupHelperService.printError({text:this.errorMessage});
      }
    })
  }

  changePubSection() {
    this.prev.emit(false)
  }

  navigate(event: any) {
    if (event.whiteLabelId._id !== this.whitLabelId)
    this.navigateTo.emit(event)

  }
  closEemit(){
    this.close.emit()
  }
}
